module.exports = __webpack_public_path__ + "static/banner-tablet-4c4e70b92bbbc8d4af8bc5ee03cb29e1.png";